<template>
<div id="app">
  <img class="logo" src="./assets/img/logo-anfr.png" alt="ANFR" v-if="error || loading || !paramconfRetrieved" />
  <div class="loading" v-if="error">
    <div style="color:#007db8;"><span class="error-icon">↺</span><span @click="fetchData" class="link">{{ $t("message['Une erreur est survenue. Veuillez recharger la page ultérieurement']") }}.</span></div>
    <div style="color:#745598"><span class="error-icon">ℹ</span><span style="color:#745598"> {{ $t("message['Ceci peut être lié à une opération de maintenance']") }}.</span></div>
    <br/>
    <div style="color:#cf378a;"><span class="error-icon">👉</span><span @click="forceContinue" class="link">{{ $t("message['Continuer quand-même']") }}.</span></div>
  </div>
  <div class="loading" v-else-if="loading || !paramconfRetrieved">
    <span style="color:#cf378a">{{ $t("message['Chargement-1']") }}</span><span style="color:#745598">{{ $t("message['Chargement-2']") }}</span><span style="color:#004e95">{{ $t("message['Chargement-3']") }}</span><span style="color:#007db8;">{{dots}}</span>
  </div>
  <div id="app" v-else>
    <cr-header/>
    <cr-menu/>
    <ChangePassword v-if="$route.query.passwordRecovery" />
    <router-view v-else />
    <cr-footer/>
    <notifications group="general-notification" position="top left" animation-type="velocity" :duration="3000" />
    <questionnaire v-if="this.$store.state.questionnaire"></questionnaire>
  </div>
</div>
</template>

<script>
import axios from 'axios'
// import storeJs from 'store'

import CrHeader from './components/CrHeader'
import CrMenu from './components/CrMenu'
import CrFooter from './components/CrFooter'

import ChangePassword from './components/changePassword'

import Questionnaire from './components/Questionnaire'

export default {
  name: 'App',
  components: {
    CrHeader,
    CrMenu,
    CrFooter,
    Questionnaire,
    ChangePassword
  },
  data() {
    return {
      addDotHandler: null,
      dots: '',
      loading: false,
      error: false,
      paramconfRetrieved: false
    }
  },
  methods: {
    forceContinue() {
      this.stopAnimation()
      this.error = false
      this.loading = false
      this.paramconfRetrieved = true
    },
    fetchParamconf() {
      axios.get('/api/v1/paramconf/info', {})
        .then((response) => {
          if (!response.data.success) {
            console.error('Une erreur s\'est produite lors de la récupération des URLs et des layers. Tout est initialisé à vide.')
          }
          response.data.data.forEach((urlObject) => {
            this.$store.state.paramUrl[urlObject.cle] = urlObject.valeur
          })
          // initialisé layer ign dans le store
          this.$store.state.ign = this.$store.state.paramUrl.LAYER_GEO
          this.paramconfRetrieved = true
        })
        .catch((error) => {
          console.debug('paramconf', error)
          this.error = true
        })
    },

    fetchData() {
      axios.get('/api/v1/utilisateurs/userdata', {})
        .then((response) => {
          if (response.data) {
            this.$store.state.user.id = response.data.id
            this.$store.state.user.login = response.data.login
            axios.get('/api/v1/cartes', {
              params: {
                idUser: response.data.id
              }
            })
              .then((maps) => {
                this.$store.state.maps = maps.data.data
              })
              .catch(function(error) {
                console.error('mymap', error)
              })
          }
        })
        .catch((error) => {
          console.debug('userdata', error)
        })
      this.stopAnimation()
      this.error = false
      this.loading = true
      if (!this.paramconfRetrieved) {
        this.fetchParamconf()
      }
      this.addDotHandler = setInterval(this.addDot, 100)
      let options = {
        timeout: 15000
      }
      axios.get('/api/v1/application/info', options)
        .then((response) => {
          this.stopAnimation()
          this.error = false
          this.loading = false
          // Afficher un questionnaire ?
          /* let questionnaireId = response.data.data.questionnaire
          response.data.data.questionnaire = null
          if (questionnaireId) {
            let hideSurvey = storeJs.get('cr:hide-survey' + questionnaireId)
            if (hideSurvey !== true) {
              axios.get('/cartoradio/web/html/questionnaire/' + questionnaireId + '.json', options)
                .then((response) => {
                  response.data.id = questionnaireId
                  this.$store.dispatch('setQuestionnaire', response.data)
                })
                .catch((error) => {
                  console.error('questionnaire', error)
                })
            }
          } */
          // Etat
          this.$store.state.params = response.data
        })
        .catch((error) => {
          this.stopAnimation()
          this.loading = false
          this.error = true
          console.error('params', error)
        })
    },
    stopAnimation() {
      if (this.addDotHandler) {
        clearInterval(this.addDotHandler)
      }
      this.addDotHandler = null
    },
    addDot() {
      if (this.dots.length > 2) {
        this.dots = ''
      } else {
        this.dots += '.'
      }
    }
  },
  created() {
    this.fetchData()
  },
  mounted() {}
}
</script>

<style>
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

#app>.logo,
#app>.loading {
  /* #app est un conteneur flex : sans align-self, le logo est étiré sur toute la largeur */
  align-self: flex-start;
  margin-left: 20px;
  margin-top: 20px;
}

#app>.loading {
  height: 120px;
  vertical-align: middle;
}

#app>.loading .error-icon {
  width: 20px;
  display: block;
  float: left;
}

#app>.loading .link {
  text-decoration: underline;
  cursor: pointer;
}

/* En cours de développement */

/*.login, .languages {
  display: none;
}*/

body .main_header {
  background-size: cover;
}

.notification {
  padding: 30px;
  margin: 0 5px 5px;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  background: #44A4FC;
  border-left: 5px solid #187FE7;
}

.notification.warn {
  background: #ffb648;
  border-left-color: #f48a06;
}

.notification.error {
  background: #E54D42;
  border-left-color: #B82E24;
}

.notification.success {
  background: #68CD86;
  border-left-color: #42A85F;
}
</style>
